import React from 'react';
import { SecurityIcon } from '@patternfly/react-icons';
import NetworkApplianceTab from './NetworkApplianceTab';

function FirewallsTab() {
  return (
    <NetworkApplianceTab
      resource="firewalls"
      nounPlural="firewalls"
      emptyIcon={SecurityIcon}
      tableAriaLabel="Firewalls list"
    />
  );
}

export default FirewallsTab;
